export const ArrowDirection = {
    Back: 'back',
    Forward: 'forward',
}



// WEBPACK FOOTER //
// ./components/Pagination/contants.js